export const modalCustomizations = {
  MuiDialog: {
    styleOverrides: {
      paper: ({ theme }) => ({
        margin: 0,
        width: "40vw", // ✅ balanced width for long forms
        height: "100vh",
        maxHeight: "100vh",
        position: "fixed",
        right: 0,
        top: 0,
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0,
        overflowY: "auto",

        [theme.breakpoints.down("sm")]: {
          width: "100vw",
          borderRadius: 0,
        },
      }),
    },
    defaultProps: {
      fullScreen: false,
      fullWidth: false,
      maxWidth: false,
    },
  },
};
